import { Action } from '../constants';

export const loginSuccess = userInfo => {
  return {
    type: Action.LOGIN_SUCCESS,
    payload: userInfo
  };
};
